<template>
  <main id="main-content">
    <HomeHero />
    <HomeAanbiedingen />
    <HomeNieuw />
    <HomeUsps />
    <HomeReviews />
    <HomeIntro />
    <NewsletterSubscribe />
  </main>
</template>

<script setup>
import HomeHero           from '@components/HomeHero.vue'
import HomeAanbiedingen   from '@components/HomeAanbiedingen.vue'
import HomeNieuw          from '@components/HomeNieuw.vue'
import HomeUsps           from '@components/HomeUsps.vue'
import HomeReviews        from '@components/HomeReviews.vue'
import HomeIntro          from '@components/HomeIntro.vue'
import NewsletterSubscribe from '@components/NewsletterSubscribe.vue'
</script>
